import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AdminLayout from "@/components/AdminLayout";
import { api, fileUrl } from "@/lib/api";
import { formatMoney } from "@/lib/currency";

const STATUS_COLORS = {
  paid: "border-brass text-brass",
  packed: "border-olive text-olive",
  shipped: "border-brass text-brass",
  delivered: "border-olive text-olive",
  completed: "border-taupe text-taupe",
  return_requested: "border-red-700 text-red-700",
  returned: "border-red-700 text-red-700",
  cancelled: "border-taupe text-taupe",
};

export default function AdminOrders() {
  const [orders, setOrders] = useState([]);
  const [status, setStatus] = useState("");

  const load = useCallback(
    () => api.get(`/orders${status ? `?status=${status}` : ""}`).then((r) => setOrders(r.data)),
    [status],
  );
  useEffect(() => { load(); }, [load]);

  return (
    <AdminLayout>
      <div data-testid="admin-orders" className="max-w-6xl">
        <span className="editorial-label">commerce · orders</span>
        <h1 className="font-serif text-5xl lowercase text-charcoal mt-3 mb-10">every transaction, traced.</h1>

        <div className="flex gap-3 mb-6">
          {["", "paid", "packed", "shipped", "delivered", "completed", "return_requested", "returned"].map((s) => (
            <button key={s || "all"} onClick={() => setStatus(s)} data-testid={`filter-${s || "all"}`} className={`text-[0.65rem] tracking-[0.25em] uppercase px-3 py-2 border ${status === s ? "border-brass text-brass" : "border-taupe text-taupe hover:border-charcoal hover:text-charcoal"}`}>
              {s || "all"}
            </button>
          ))}
        </div>

        <div className="overflow-x-auto border border-taupe/40">
          <table className="w-full text-sm">
            <thead className="bg-linen">
              <tr className="text-left">
                {["order", "piece", "buyer", "country", "total", "status", "tracking"].map((h) => (
                  <th key={h} className="editorial-label px-4 py-4 border-b border-taupe/50">{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {orders.map((o, i) => (
                <tr key={o.id} className="border-b border-taupe/30 hover:bg-linen/50" data-testid={`order-row-${i}`}>
                  <td className="px-4 py-3"><Link to={`/admin/orders/${o.id}`} className="font-serif text-base lowercase text-charcoal hover:text-brass">{o.order_number}</Link><br/><span className="text-[0.65rem] text-taupe tracking-widest uppercase">{new Date(o.created_at).toLocaleDateString()}</span></td>
                  <td className="px-4 py-3">
                    <div className="flex items-center gap-3">
                      {o.item_snapshot?.photo && <img src={fileUrl(o.item_snapshot.photo) + "?size=thumb"} alt="" className="w-10 h-10 object-cover" />}
                      <span className="text-sm text-charcoal lowercase font-serif">{o.item_snapshot?.title}</span>
                    </div>
                  </td>
                  <td className="px-4 py-3 text-charcoal text-sm">{o.buyer_name}<br/><span className="text-xs text-taupe">{o.buyer_email}</span></td>
                  <td className="px-4 py-3 text-xs uppercase tracking-widest text-charcoal">{o.country}</td>
                  <td className="px-4 py-3 text-charcoal">{formatMoney(o.total)}</td>
                  <td className="px-4 py-3"><span className={`text-[0.65rem] tracking-widest uppercase px-2 py-1 border ${STATUS_COLORS[o.status] || ""}`}>{o.status}</span></td>
                  <td className="px-4 py-3 text-xs text-taupe">{o.tracking_number || "—"}</td>
                </tr>
              ))}
              {orders.length === 0 && (
                <tr><td colSpan="7" className="text-center py-12 font-serif text-2xl lowercase text-taupe">no orders match.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </AdminLayout>
  );
}
